import { newRelicJSError } from '@nmx/utils/dist/utilities/frontend/Analytics/new_relic_helper';

// eslint-disable-next-line import/prefer-default-export
export function bingTrackLead() {
  try {
    window.uetq = window.uetq || [];
    window.uetq.push({
      ec: 'lead',
      ea: 'click',
      el: 'find an advisor',
    });
  } catch (err) {
    const error = `Error tracking lead form submission for Bing Pixel: ${err}`;
    newRelicJSError(error);
    console.error(error);
  }
}

